// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"bd1e7038","522":"1f96a69c","557":"4a80f22d","627":"7d438c97","681":"d37fde01","697":"50535253","706":"896a1b97","787":"efd935e6"}[chunkId] + ".chunk.js";
};